import { FC, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useQuery } from 'react-query';

import API from 'core/Api';

import { useLanguageContext } from 'store/language';
import { useActiveClientContext } from 'store/active-client';

import { buildClientEntity } from 'utils/helpers/client';
import { formatDate } from 'utils/helpers/formatters';

import InnerWrapper from 'routes/client/reports/InnerWrapper';
import ReportForm from 'routes/client/reports/work-trips/components/ReportForm';
import TripsTable from 'routes/client/reports/work-trips/components/TripsTable';

type ReportParams = Partial<{
  date_from: string;
  date_to: string;
  user: Array<string | number>;
  group: Array<string | number>;
  status: Array<string | number>;
}>;

const WorkTripsReport: FC = () => {
  const methods = useForm();
  const { client } = useActiveClientContext();
  const { language } = useLanguageContext();

  const [reportParams, setReportParams] = useState<ReportParams | null>(null);

  const {
    isLoading: isLoadingDropdowns,
    error: errorDropdowns,
    data: dropdowns,
  } = useQuery<any, Error>([buildClientEntity('report-work-trips-dropdowns', client)], (): Promise<any> => {
    return API.get('reports/work-trips/dropdown-options').then(res => {
      return res.data[language || 'bg'];
    });
  });

  const handleSubmitReport = (data: any) => {
    const dateFrom = data.date_from ? formatDate(data.date_from, 'YYY/mm/dd') : null;
    const dateTo = data.date_to ? formatDate(data.date_to, 'YYY/mm/dd') : null;

    const formattedData: ReportParams = {
      date_from: dateFrom || undefined,
      date_to: dateTo || undefined,
      user: data.user?.map((user: any) => user.value),
      group: data.group?.map((group: any) => group.value),
      status: data.status?.map((status: any) => status.value),
    };

    setReportParams(formattedData);
  };

  return (
    <InnerWrapper
      isLoading={isLoadingDropdowns}
      error={errorDropdowns}
    >
      {dropdowns && (
        <ReportForm
          data={dropdowns}
          methods={methods}
          onSubmit={handleSubmitReport}
          reportParams={reportParams}
        />
      )}
      {reportParams && (
        <div className="mt-3">
          <TripsTable reportParams={reportParams} />
        </div>
      )}
    </InnerWrapper>
  );
};

export default WorkTripsReport;
